import React from 'react';
import ConductLedger from './ConductLedger';

function TeacherProfileCard({ user, cls, onDailyAttendanceHW, onTakeAttendance, onMasterAttendance, onMyAttendance, onChangePassword, onLogout }) {
  const rows = [
    ['Name', user.name], ['Email', user.email], ['Designation', user.designation],
    ['Subject', user.subject], ['Class', cls], ['Mobile', user.mobile]
  ].filter(([, v]) => v);
  return (
    <section className="th-card">
      <div className="th-card-head"><h2>Profile &amp; Settings</h2></div>
      {rows.map(([k, v]) => (
        <div className="th-row" key={k}><span className="th-muted">{k}</span><span>{v}</span></div>
      ))}
      {onDailyAttendanceHW && (
        <button
          className="th-btn"
          onClick={onDailyAttendanceHW}
          style={{ width: '100%', minHeight: 56, margin: '12px 0', fontSize: 16, fontWeight: 800, background: '#16a34a', color: '#fff', border: '2px solid #15803d', borderRadius: 14 }}
        >
          📋 Mark Daily Attendance &amp; Homework
        </button>
      )}
      <ConductLedger viewer={user} teacherId={user._id || user.id} />
      <div className="th-actions">
        {onTakeAttendance && <button className="th-btn" onClick={onTakeAttendance}>📋 Take Today's Attendance</button>}
        {onMasterAttendance && <button className="th-btn" onClick={onMasterAttendance}>🗂️ Master Attendance &amp; WhatsApp</button>}
        <button className="th-btn th-btn-outline" onClick={onMyAttendance}>My Attendance</button>
        {onChangePassword && <button className="th-btn th-btn-outline" onClick={onChangePassword}>Change Password</button>}
        <button className="th-btn th-btn-danger" onClick={onLogout}>Logout</button>
      </div>
    </section>
  );
}

export default TeacherProfileCard;
